import Layout from "@/components/feature/Layout";
import PageHero from "@/components/base/PageHero";
import SectionHeader from "@/components/base/SectionHeader";
import { Link } from "react-router-dom";

const resourceLinks = [
  {
    title: "Capability Statement",
    description: "Mitaja Corporation capability statement for government procurement officers, prime contractors, and teaming partners. Available upon request.",
    href: "/resources/capability-statement",
    icon: "ri-file-list-line",
  },
  {
    title: "Contracting Information",
    description: "GSA MAS, UEI, CAGE, NAICS codes, and business status information for procurement and qualification.",
    href: "/resources/contracting-information",
    icon: "ri-file-list-line",
  },
  {
    title: "Insights",
    description: "Practical thought leadership on enterprise IT engineering, database and platform services, application integration, and delivery teams.",
    href: "/resources/insights",
    icon: "ri-file-list-line",
  },
  {
    title: "Types & Bid Categories",
    description: "A practical map of where Mitaja can bid, which capabilities support each category, and what must be in place before pursuit.",
    href: "/resources/project-types",
    icon: "ri-map-2-line",
  },
];

export default function Resources() {

  return (
    <Layout>
      <PageHero
        title="Resources"
        subtitle="Information & Documentation"
        description="Capability statements, contracting information, and insights for government procurement and teaming partners."
        size="md"
      />

      <section className="section-padding bg-white">
        <div className="container-page">
          <SectionHeader
            title="Available Resources"
            description="Documents and information for procurement officers, prime contractors, and prospective partners."
          />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {resourceLinks.map((link) => (
              <Link
                key={link.title}
                to={link.href}
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="card-base card-hover p-8 cursor-pointer group block"
              >
                <div className="w-14 h-14 rounded-xl bg-primary-50 flex items-center justify-center mb-6 group-hover:bg-primary-100 transition-colors">
                  <i className={`${link.icon} text-primary-600 text-2xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-foreground-900 mb-3 group-hover:text-primary-700 transition-colors">
                  {link.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-5">
                  {link.description}
                </p>
                <span className="flex items-center text-sm font-semibold text-primary-600 group-hover:text-primary-700 transition-colors">
                  View resource
                  <i className="ri-arrow-right-line ml-1 group-hover:translate-x-1 transition-transform" aria-hidden="true"></i>
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}